import React, { memo, useRef } from "react";
import { AddPhoto, Danger, Info } from "@bale/ui";
import { strings } from "intl/fa";
import classNames from "classnames";
import styles from "./FileInput.module.scss";
import ImageInputPreview from "./ImageInputPreview";
import InputNote from "../inputNote/InputNote";
import { useTheme } from "@emotion/react";

interface Props {
  file?: File | undefined;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  title?: string;
  error?: string;
  helpText?: string;
  label?: string;
}
const FileInput: React.FC<React.PropsWithChildren<Props>> = (props) => {
  const theme = useTheme();
  const imageRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (imageRef.current) imageRef.current.value = "";
    imageRef.current?.click();
  };

  return (
    <>
      <div className={styles.Wrapper}>
        {props.title && <p className={styles.Title}>{props.title}</p>}
        {props.file ? (
          <ImageInputPreview
            file={props.file}
            onEdit={handleClick}
            label={props.label}
          />
        ) : (
          <div
            onClick={handleClick}
            className={classNames(styles.Container, {
              [styles.HasError]: props.error,
            })}
          >
            <AddPhoto size={24} color={theme.colors.primary[50]} />
            <span className={styles.Text}>
              {strings.common.input.file.label}
            </span>
          </div>
        )}
        {props.error ? (
          <InputNote
            icon={<Danger size={20} color={theme.colors.error} />}
            textClassName={styles.AlertText}
            text={props.error}
          />
        ) : (
          props.helpText && (
            <InputNote
              icon={<Info size={20} color={theme.colors.dark[300]} />}
              text={props.helpText ?? ""}
            />
          )
        )}
      </div>
      <input
        ref={imageRef}
        className={styles.Input}
        type="file"
        hidden
        accept="image/jpeg, image/png, application/pdf"
        onChange={props.onChange}
      />
    </>
  );
};

export default memo(FileInput);
